import * as React from "react";
import {Button, Checkbox, Icon, Message, Segment} from 'semantic-ui-react';
import {authentication} from "../../../../../authentication";
import {backend} from "../../../../../xconvert-backend";
import {ConfigContext} from "../../../context/ConfigContext";
import ReactTable from "react-table";
import {formatDate} from "../../../../../format";
import {IfBox} from "../../../../style/if";
import {TestModal} from "./TestModal";
import {
    SwitchActiveTransportOrderConfigTestsRequest,
    TriggerTransportOrderConfigTestsRequest
} from "../../../../../generated"
import {TestResultModal} from "./TestResultModal";
import Notifications, {notify} from 'react-notify-toast';
import {TestDeleteModal} from "./TestDeleteModal";
import {LogView} from "../../logView/LogView";
import {MultiTestResultModal} from "./MultiTestResultModal";
import { updateConfig, workingConfig } from "../../configChange/ConfigSignal";


export interface TransportOrderConfigTestsProps {

}

export interface TransportOrderConfigTestsState {
    isLoading: boolean
    testsLoading: boolean
    testToShow: any
    showTest: boolean
    testResults: any
    selectedTestResult: any
    lastTest: any
    lastTests: any[]
    showTestResult: boolean
    showMultiTestResult: boolean
    testToDelete: any
    showTestDelete: boolean
    allSelected: boolean
    lastSuccessConfig: any
    xRequestId: string | null
    errorMessage: any
    take: number
    sortBy: string
    sortDirection: "ASC" | "DESC"
    response: any

}

export class TransportOrderConfigTests extends React.Component<TransportOrderConfigTestsProps, TransportOrderConfigTestsState> {

    static contextType = ConfigContext
    context!: React.ContextType<typeof ConfigContext>;

    constructor(props) {
        super(props)
        console.log("loading TransportOrderConfigTests")

        this.state = {
            isLoading: false,
            testsLoading: false,
            testToShow: null,
            showTest: false,
            testResults: null,
            selectedTestResult: null,
            lastTest: null,
            lastTests: [],
            showTestResult: false,
            showMultiTestResult: false,
            testToDelete: null,
            showTestDelete: false,
            allSelected: false,
            lastSuccessConfig: null,
            xRequestId: null,
            errorMessage: null,
            take: 25,
            sortBy: "CREATED",
            sortDirection: "ASC",
            response: null,
        }
    }

    async componentDidMount() {
        this.loadTests()
    }

    switchSelectionStateOfItem(id: string) {
        this.setState({isLoading: true})

        var array = [...this.context.selectedTests]; // make a separate copy of the array
        var index = array.indexOf(id)
        if (index == -1) {
            // id not found, adding Id

            this.context.setSelectedTests(array.concat(id))
            console.log("Id added")


        } else {
            // Id found, removing it

            array.splice(index, 1);
            this.context.setSelectedTests(array)
            console.log("Id removed")

        }
        this.setState({isLoading: false})
    }

    selectOrUnselectAll() {
        if (this.state.allSelected) {
            console.log("select None")
            this.context.setSelectedTests([])
            this.setState({allSelected: false})
        } else {
            console.log("select All")
            let all = this.context.tests.map((it) => {
                return it._id
            })
            this.context.setSelectedTests(all)
            this.setState({allSelected: true})
        }
    }

    async loadTests(pageIndex: number = 0) {
        this.setState({isLoading: true})
        //load tests
        let auth = backend.withTokenAuthHeader(authentication.token)

        let tests = (await backend.internalApi.listTransportOrderConfigTests(this.context.companyId, null, null, null, null, null, auth)).tests
        console.log(tests)
        //save testList in context
        this.context.setTests(tests)

        this.setState({isLoading: false})

    }

    async switchActive(id: string, newActive: boolean) {
        this.setState({isLoading: true})

        let request = {} as SwitchActiveTransportOrderConfigTestsRequest
        request.testId = id
        request.newActive = newActive
        let auth = backend.withTokenAuthHeader(authentication.token)

        await backend.internalApi.switchActiveTransportOrderConfigTest(request, auth)
        this.loadTests()
        this.setState({isLoading: false})
    }

    async triggerTest(ids: string[]) {
        console.log("trigger tests with id: ", ids)
        this.setState({testsLoading: true})

        let configWithoutDefaults = workingConfig.value

        if (!configWithoutDefaults) {
            console.log("config in context is null. Loading config from backend")
            let auth = backend.withTokenAuthHeader(authentication.token)
            let currentCompanyConfig = (await backend.internalApi.fetchCompanyConfiguration(this.context.companyId, auth))
            configWithoutDefaults = JSON.stringify(currentCompanyConfig, null, 4)
            await updateConfig(configWithoutDefaults, true, true)
        }

        let request = {} as TriggerTransportOrderConfigTestsRequest
        request.config = JSON.parse(configWithoutDefaults)
        request.companyId = this.context.companyId
        request.testIds = ids


        let auth = backend.withTokenAuthHeader(authentication.token)
        let result = (await this.triggerTransportOrderTestsWithXRequestId(request, auth))

        this.setState({testResults: result.results, selectedTestResult: result.results[0]})


        if (ids.length == 1) {
            let id = ids[0]
            let test = this.context.tests.find((test) => test._id == id)
            this.setState({showTestResult: true, lastSuccessConfig: test.lastSuccessfulConfig, lastTest: test})
        } else {
            let tests = this.context.tests.filter((test) => ids.includes(test._id) )
            this.setState({showMultiTestResult: true, lastSuccessConfig: this.context.tests[0].lastSuccessfulConfig, lastTests: tests})
            notify.show('triggered selected ' + ids.length + ' tests', 'success', 3000, '#28f751');
        }
        this.loadTests()

        console.log("Server responded with: ", result)
        this.setState({testsLoading: false})

    }

    async triggerTransportOrderTestsWithXRequestId(request, auth) {
        // since using the auto-generated api is only returning the TransportOrder without the xRequestId
        // I'm calling the endpoint manually to be able to extrackt the xRequestId for the logs


            let response = await fetch('/api/internal/company/triggerTransportOrderConfigTests', {
                method: 'POST',
                headers: {
                    "Authorization": auth.headers.Authorization,
                    "Content-Type": "application/json; charset=utf-8"
                },
                body: JSON.stringify(request)
            })
            console.log("triggerTransportOrderConfigTest response: ", response)

            if(!response.ok) {
                this.setState({errorMessage: await response.text()})
            } else {
                this.setState({errorMessage: null})
            }
            let resp = await response.json()

            this.setState({xRequestId: response.headers.get("x-request-id")})

            return resp


    }

    deleteTest(id: string) {
        console.log("delete Test : ", id)

        let test = this.context.tests.find((test) => {
            return test._id == id
        })

        if (test == null) {
            notify.show('Could not find test ', 'error', 5000, '#fc0303');
            return
        }

        this.setState({testToDelete: test, showTestDelete: true})

    }

    render() {

        const companyName = authentication.company.name

        return <span>

            {
                this.renderButtons()
            }
            {
                this.renderTable()
                // display testList from context
                // onClick should open a view on the test
                // give buttons for the following actions
                //      Play button to trigger single test
                //      Checkbox to select several tests
                //      Trash button to delete test (with warning where the user has to confirm)
                //      disable button to disable test
                // above the table show these buttons:
                //      Checkbox to select/disselect all
                //      Play button to trigger all selected tests
                //      disable button to disable all selected tests

            }
            <h4>Logs:</h4>
            <LogView
                query={this.state.xRequestId}
                origin={"transportOrderConfigTest"}
                initialTimespan={null}
                responseLogs={null}
            />

            <IfBox shouldShow={this.state.showTest}>
                <TestModal isOpen={this.state.showTest}
                           onClose={() => this.setState({showTest: false, testToShow: null})}
                           test={this.state.testToShow}/>
            </IfBox>
            <IfBox shouldShow={this.state.showTestResult}>
                <TestResultModal
                    isOpen={this.state.showTestResult}
                    onClose={() => this.setState({showTestResult: false, testToShow: null, lastSuccessConfig: null})}
                    testResult={this.state.selectedTestResult}
                    lastSuccessConfig={this.state.lastSuccessConfig}
                    test={this.state.lastTest}
                />
            </IfBox>
            <IfBox shouldShow={this.state.showMultiTestResult}>
                <MultiTestResultModal
                    isOpen={this.state.showMultiTestResult}
                    onClose={(success) => {
                        if(success) {
                            notify.show('tests has been updated', 'success', 3000, '#28f751');
                        } else {
                            notify.show("ERROR: tests didn't update completely", 'error', 5000, '#fc0303');
                        }
                        this.setState({showMultiTestResult: false, testToShow: null, lastSuccessConfig: null})
                    }}
                    testResults={this.state.testResults}
                    lastSuccessConfig={this.state.lastSuccessConfig}
                    tests={this.state.lastTests}
                />
            </IfBox>
            <IfBox shouldShow={this.state.showTestDelete}>
                <TestDeleteModal isOpen={this.state.showTestDelete} onClose={() => this.closeDeleteModal()}
                                 test={this.state.testToDelete}/>
            </IfBox>

            <Notifications/>

        </span>;
    }

    closeDeleteModal() {
        this.setState({showTestDelete: false, testToDelete: null})
        this.loadTests()
    }

    renderButtons() {
        return <Segment>
            {/*  select all CheckBox */}
            <Checkbox onChange={() => this.selectOrUnselectAll()}/> All

            {/* trigger selected Play button */}
            <Button icon
                    loading={this.state.testsLoading}
                    onClick={() => {
                        this.triggerTest(this.context.selectedTests)
                    }}>
                <Icon name='play'/>
            </Button>
            {/* delete selected Trash button */}

            {/* activate / deactivate selected button */}


            <IfBox shouldShow={this.state.errorMessage != null}>
                <Message negative={true} compact={true} >
                    <Message.Header>
                        ERROR:
                    </Message.Header>
                    <Message.Content>
                        {this.state.errorMessage}
                    </Message.Content>
                </Message>
            </IfBox>
        </Segment>
    }

    renderTable() {
        const columns = [
            {
                id: 'select',
                Header: 'Select',
                width: 50,
                accessor: (d: any) => {
                    return <Checkbox
                        checked={this.context.selectedTests.some(id => id === d._id)}
                        onChange={() => this.switchSelectionStateOfItem(d._id)}
                    />
                },
                sortField: 'NONE'
            }, {
                id: '_id',
                Header: 'ID',
                width: 200,
                accessor: (d: any) => d._id,
                sortField: 'ID'
            }, {
                id: 'type',
                Header: 'Type',
                width: 70,
                accessor: (d: any) => d.type,
                sortField: 'TYPE'
            }, {
                id: 'name',
                Header: 'Name',
                width: 350,
                accessor: (d: any) => d.name,
                sortField: 'NAME'
            }, {
                id: 'lastRun',
                Header: 'Last Run',
                width: 150,
                accessor: (d: any) => d.lastRun,
                Cell: (d: any) => {
                    return <span>{formatDate(d.value)}</span>
                },
                sortField: 'LAST_RUN'
            }, {
                id: 'lastSuccessfulRun',
                Header: 'Last Successful Run',
                width: 150,
                accessor: (d: any) => d.lastSuccessfulRun,
                Cell: (d: any) => {
                    return <span>{formatDate(d.value)}</span>
                },
                sortField: 'LAST_SUCCESSFUL_RUN'
            }, {
                id: 'success',
                Header: 'Success',
                width: 100,
                accessor: (d: any) => {
                    if (d.success) {
                        return <Icon name='check' color='green' size='large'/>
                    } else {
                        return <Icon name='x' color='red' size='large'/>
                    }
                },
                sortField: 'SUCCESS'
            }, {
                id: 'created',
                Header: 'Created',
                width: 150,
                accessor: (d: any) => d.created,
                Cell: (d: any) => {
                    return <span>{formatDate(d.value)}</span>
                },
                sortField: 'CREATED'
            }, {
                id: 'modified',
                Header: 'Modified',
                width: 150,
                accessor: (d: any) => d.modified,
                Cell: (d: any) => {
                    return <span>{formatDate(d.value)}</span>
                },
                sortField: 'MODIFIED'
            }, {
                id: 'active',
                Header: 'Active',
                width: 70,
                accessor: (d: any) => {
                    return <Checkbox
                        onChange={() => this.switchActive(d._id, !d.active)}
                        value={d.active}
                        checked={d.active}
                    />
                },
                sortField: 'ACTIVE'
            }, {
                id: 'trigger',
                Header: 'Trigger',
                width: 70,
                accessor: (d: any) => {
                    return <Button icon
                                   loading={this.state.testsLoading}
                                   onClick={() => {
                                       this.triggerTest([d._id])
                                   }}>
                        <Icon name='play'/>
                    </Button>
                },
                sortField: 'NONE'
            }, {
                id: 'delete',
                Header: 'Delete',
                width: 70,
                accessor: (d: any) => {
                    return <Button icon
                                   onClick={() => this.deleteTest(d._id)}>
                        <Icon name='trash'/>
                    </Button>
                },
                sortField: 'NONE'
            },

        ]

        let data = this.context.tests
        return <ReactTable
            data={data}
            pages={Math.ceil(data.length / this.state.take)}
            columns={columns}
            onSortedChange={(newSorted, column, shiftKey) => {
                this.changeSort(column.sortField)
            }}
            sorted={[
                {
                    id: 'dir',
                    desc: false
                }
            ]}
            defaultPageSize={this.state.take}
            className="-striped -highlight"
            loading={this.state.isLoading}
            getTdProps={(state, rowInfo, column, instance) => {
                return {
                    onClick: () => {
                        if (rowInfo) {
                            if (column.id != 'trigger'
                                && column.id != 'delete'
                                && column.id != 'select'
                                && column.id != 'active') {
                                // open testView
                                this.showTest(rowInfo.row._id)
                            }
                        }
                    }
                };
            }}
            style={{cursor: "pointer"}}
            onPageChange={(pageIndex) => this.changePage(pageIndex)}
            onPageSizeChange={(pageSize, pageIndex) => this.changePageSize(pageSize)}
        />

    }

    showTest(id: string) {
        let test = this.context.tests.find(function (element) {
            return element._id == id;
        })
        this.setState({testToShow: test, showTest: true})
    }

    changePage(pageIndex: number) {
        this.loadTests(pageIndex)
    }

    changePageSize(newSize: number) {
        this.setState({take: newSize, response: null})
        this.loadTests()
    }

    changeSort(sortBy: 'ID' | 'NAME' | 'LAST_RUN' | 'LAST_SUCCESSFUL_RUN' | 'SUCCESS' | 'ACTIVE' | 'CREATED' | 'MODIFIED' | 'NONE') {

        if (sortBy == 'NONE') {
            return
        }
        if (this.state.sortBy == sortBy) {
            //change direction
            let direction = this.state.sortDirection
            if (direction == "ASC") {
                direction = "DESC"
            } else {
                direction = "ASC"
            }
            this.setState({sortDirection: direction})
        } else {
            //change sortBy and reset direction
            this.setState({sortBy: sortBy, sortDirection: "ASC"})
        }

        //refresh
        this.loadTests()
    }

}